import { cn } from "@devhop/ui";

const WIZARD_STEPS = [
  { n: 1, label: "ເລືອກສາຂາ & ສິນຄ້າ" },
  { n: 2, label: "ລາຍລະອຽດຮັບເຂົ້າ" },
  { n: 3, label: "ຢືນຢັນ" },
] as const;

type ReceiveWizardProgressProps = {
  step: number;
};

export function ReceiveWizardProgress({ step }: ReceiveWizardProgressProps) {
  return (
    <nav aria-label="ຂັ້ນຕອນຮັບເຂົ້າສາງ" className="mb-6">
      <ol className="flex items-center gap-1 sm:gap-2">
        {WIZARD_STEPS.map((s, index) => (
          <li key={s.n} className="flex min-w-0 flex-1 items-center gap-1 sm:gap-2">
            <div
              className={cn(
                "flex size-7 shrink-0 items-center justify-center rounded-full font-semibold text-xs sm:size-8 sm:text-sm",
                step >= s.n
                  ? "bg-primary text-primary-foreground"
                  : "bg-muted text-muted-foreground",
              )}
              aria-current={step === s.n ? "step" : undefined}
            >
              {s.n}
            </div>
            <span
              className={cn(
                "hidden min-w-0 truncate text-xs leading-tight sm:inline",
                step >= s.n
                  ? "font-medium text-foreground"
                  : "text-muted-foreground",
              )}
            >
              {s.label}
            </span>
            {index < WIZARD_STEPS.length - 1 ? (
              <div
                className={cn(
                  "mx-0.5 h-0.5 min-w-[0.75rem] flex-1 rounded sm:mx-1",
                  step > s.n ? "bg-primary" : "bg-muted",
                )}
                aria-hidden
              />
            ) : null}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export { WIZARD_STEPS };
